import PagesToolbarContainer from './PagesToolbarContainer';
import BarContainer from './BarContainer';
import FiltersContainer from './FiltersContainer';
import FiltersResultsContainer from './FiltersResultsContainer';
import FiltersSidebarContainer from './FiltersSidebarContainer';
import ActionsContainer from './ActionsContainer';
// Actions
import * as Actions from './Actions';

export { Actions };

const PagesToolbar = Object.assign(PagesToolbarContainer, {
  Bar: BarContainer,
  Filters: FiltersContainer,
  FiltersResults: FiltersResultsContainer,
  FiltersSidebar: FiltersSidebarContainer,
  Actions: ActionsContainer
});

export default PagesToolbar;
